// extracted by css-extract-rspack-plugin
export default {"root":"root-psxEN_","title":"title-tZy411","search":"search-tHxl95"};